import { useCallback } from 'react'
import HelpTooltip from '../../../../components/tooltip/HelpTooltip'
import { CampaignTypeNames, CampaignTypes } from '../../../Codes'
import RadioButton from '../../../../components/form/RadioButton'
import { useDispatch, useSelector } from 'react-redux'
import PropTypes from 'prop-types'
import { setCampaignType } from '../campaignSlice'
import { GitbookLinks } from '../../../../utils/constants'

const CampaignType = ({ modify }) => {
  const dispatch = useDispatch()
  const { campaignType } = useSelector(state => state.ad.campaign.form)
  const handleChange = useCallback(
    value => dispatch(setCampaignType(value)),
    [dispatch]
  )
  return (
    <div className="area_item">
      <strong className="subtit_box">
        캠페인 유형
        <HelpTooltip>해당 캠페인의 목적을 의미합니다.</HelpTooltip>
      </strong>
      <div className="cont_card">
        {modify ? (
          <p className="desc_g">{CampaignTypeNames[campaignType]}</p>
        ) : (
          <>
            <div className="item_card">
              <ul className="list_radiocheck">
                <li>
                  <RadioButton
                    name="campaignType"
                    value={CampaignTypes.PREMIUM_LINK}
                    label={CampaignTypeNames[CampaignTypes.PREMIUM_LINK]}
                    checked={campaignType === CampaignTypes.PREMIUM_LINK}
                    onValueChange={handleChange}
                  />
                  <p className="desc_item">
                    주요 포털 검색 및 제휴 매체등에 키워드검색으로 사용자의
                    의도를 파악하여 정보 전달이 가능한 광고
                    <a
                      href={GitbookLinks.PREMIUM_LINK}
                      target="_blank"
                      className="link_txt2"
                      rel="noopener noreferrer">
                      자세히보기
                    </a>
                  </p>
                </li>
                <li>
                  <RadioButton
                    name="campaignType"
                    value={CampaignTypes.TALK_CHANNEL}
                    label={CampaignTypeNames[CampaignTypes.TALK_CHANNEL]}
                    checked={campaignType === CampaignTypes.TALK_CHANNEL}
                    onValueChange={handleChange}
                  />
                  <p className="desc_item">
                    카카오톡 검색결과에 채널의 정보를 노출하여 친구 추가 확대 및
                    랜딩 브리지 역할을 할 수 있는 광고
                    <a
                      href={GitbookLinks.TALK_CHANNEL}
                      target="_blank"
                      className="link_txt2"
                      rel="noopener noreferrer">
                      자세히보기
                    </a>
                  </p>
                </li>
              </ul>
            </div>
          </>
        )}
      </div>
    </div>
  )
}
CampaignType.propTypes = {
  modify: PropTypes.bool.isRequired,
}
export default CampaignType
